import React, { Fragment, useEffect, useState } from "react";
import { set_order_detail } from "../../../redux/actions/OrdersAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";
import Header from "../subheader/Header";
import "./orderdetails.scss";
import OrderHeader from "./components/OrderHeader";
import Shipment from "./components/Shipment";
import OrderSummary from "./components/OrderSummary";
import ShipmentService from "./components/ShipmentService";
import { useParams } from "react-router-dom";

const OrderDetails = (props) => {
  const [data, setData] = useState(false);
  const param = useParams();

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Order";
  }, []);

  useEffect(() => {
    apiJson.orders.getOrderDetail(parseInt(param.id)).then((response) => {
      if (response.success) {
        props.set_order_detail({ orderDetail: response.data });
        setData(true);
      } else if (!response.status) {
        setData(true);
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right order-details-page-desktop">
        <Header heading="Order Details" search={false} filters={null} />
        <div className="right-content order-details-right-content">
          {data && (
            <div className="content-container right-content-wrapper">
              <div className="content-wrapper mx-auto">
                <div className="order-header">
                  <OrderHeader orderDetail={props.orderDetail} />
                </div>
                {props.orderDetail?.shipment && (
                  <div className="shipments">
                    <Shipment orderDetail={props.orderDetail} />
                  </div>
                )}
                {props.orderDetail.services &&
                  props.orderDetail.services.map((service) => {
                    return (
                      <div className="shipments" key={service.id}>
                        <ShipmentService
                          service={service}
                          currency={props.orderDetail?.currency}
                        />
                      </div>
                    );
                  })}

                <div className="order-summary">
                  <OrderSummary orderDetail={props.orderDetail} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    orderDetail: state.order.orderDetail,
    load: state.layout.isLoading,
  };
};

const mapDispatchToProps = { set_order_detail, set_loading };

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
